import { useMediaQuery, useBreakpoints, breakpointsTailwind } from '@vueuse/core';
import { computed } from 'vue';

export const useEnviroment = () => {
  const breakpoints = useBreakpoints(breakpointsTailwind);
  const isPWA = useMediaQuery('(display-mode: standalone)');
  const isSM = breakpoints.smallerOrEqual('sm');

  const { VITE_IS_STAGING } = import.meta.env;
  const isStaging = !!VITE_IS_STAGING && VITE_IS_STAGING !== 'false';

  const isMobile = computed(() => isPWA.value || isSM.value);

  return {
    isPWA,
    isMobile,
    isStaging,
  };
};
